import { Auth0Provider } from '@auth0/auth0-react';
import { ReactNode } from 'react';
import { AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUTH0_AUDIENCE, AUTH0_SCOPES } from '../config';

type AuthWrapperProps = {
    children: ReactNode | ReactNode[];
};

function AuthWrapper({ children }: AuthWrapperProps): JSX.Element {
    const isMock = process.env.REACT_APP_MOCK_USER === 'true';
    return isMock ? (
        <>{children}</>
    ) : (
        <Auth0Provider
            domain={AUTH0_DOMAIN}
            clientId={AUTH0_CLIENT_ID}
            authorizationParams={{ redirect_uri: window.location.origin, audience: AUTH0_AUDIENCE, scope: AUTH0_SCOPES }}
            useRefreshTokens
            skipRedirectCallback={location.pathname === '/callback/xero'}
            cacheLocation="localstorage"
        >
            {children}
        </Auth0Provider>
    );
}

export default AuthWrapper;
